import axios from 'axios';
import { isTokenValid } from '../../../utils/index';

// Create an Axios instance with base URL and any other default config
const axiosInstance = axios.create();

// Add an interceptor to attach the authentication header
axiosInstance.interceptors.request.use((config) => {
  const authToken = JSON.parse(sessionStorage.getItem('user'))?.access_token;
  if (authToken) {
    config.headers['Authorization'] = `Bearer ${authToken}`;
  }
  return config;
});

const isProdEnv =
  process.env.REACT_APP_ENV === 'PRODUCTION' ||
  // process.env.NODE_ENV === 'production' ||
  window.location.hostname === 'brandastra.ai';
  
  const pathSegments = window.location.pathname.split('/').filter(Boolean);
  

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {

    const authToken = JSON.parse(sessionStorage.getItem('user'))?.access_token;
    // if (!isTokenValid(authToken)) {
    //   sessionStorage.removeItem('user');
    //   window.location.href = '/brandAstra/login';
    // }
     if (!isTokenValid(authToken)) { 
      sessionStorage.removeItem('persist:root');

          sessionStorage.removeItem('brandUser');
          const loginRedirect = isProdEnv
            ? '/login'
            : pathSegments.length > 0
            ? `/${pathSegments[0]}/login`
            : '/login';
    
          window.location.href = loginRedirect;
        }
    return Promise.reject(error);
  }
);
export default axiosInstance;
